export interface CopiedObjectLocation {
  oldKey: string;
  newKey: string;
  newUrl: string;
}

interface BuildCopiedObjectLocationOptions {
  sourceUrl: string;
  bucket: string;
  fileName: string;
}

export function buildCopiedObjectLocation({
  sourceUrl,
  bucket,
  fileName,
}: BuildCopiedObjectLocationOptions): CopiedObjectLocation {
  const parsedUrl = new URL(sourceUrl);
  const sourcePath = decodeURIComponent(parsedUrl.pathname).replace(/^\//, '');
  const bucketPrefix = `${bucket}/`;
  const hasBucketPrefix = sourcePath.startsWith(bucketPrefix);
  const oldKey = hasBucketPrefix ? sourcePath.slice(bucketPrefix.length) : sourcePath;
  const extensionIndex = oldKey.lastIndexOf('.');
  const extension = extensionIndex >= 0 ? oldKey.substring(extensionIndex) : '';
  const directoryIndex = oldKey.lastIndexOf('/');
  const directory = directoryIndex >= 0 ? oldKey.substring(0, directoryIndex + 1) : '';
  const newKey = `${directory}${fileName}${extension}`;
  parsedUrl.pathname = `/${hasBucketPrefix ? bucketPrefix : ''}${newKey}`;
  parsedUrl.search = '';
  parsedUrl.hash = '';
  return {
    oldKey,
    newKey,
    newUrl: parsedUrl.toString(),
  };
}

const ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz';
const BASE = 36n;
const MOD = BASE ** 6n; // 36^6 = 2176782336

/**
 * 32 位 MD5 十六进制字符串 -> 6 位字符串
 * 同一个 MD5 永远得到同一个结果
 * 不保证不同 MD5 不冲突
 */
export function md5To6(md5Hex: string) {
  const hex = String(md5Hex).trim().toLowerCase();

  if (!/^[0-9a-f]{32}$/.test(hex)) {
    throw new Error('Invalid MD5 hex string');
  }

  const n = BigInt('0x' + hex);
  let x = n % MOD;

  const chars = [];
  for (let i = 0; i < 6; i++) {
    const idx = Number(x % BASE);
    chars.push(ALPHABET[idx]);
    x = x / BASE;
  }

  return chars.reverse().join('');
}

